import React, { useEffect, useRef } from "react";
import { Callout, Icon } from "../../SpaAdminScope";
import { callout } from "@harmony/enablers/react";

export interface CustomCalloutProps {
    name: string;
    message: JSX.Element;
    displayValue?: string;
}

export const CustomCallout: React.FC<CustomCalloutProps> = ({
    name,
    message,
    displayValue
}) => {

    useEffect(() => {
        const callout = document.getElementById(name + '_callout');
        const popup = callout?.shadowRoot?.querySelector('[part="popup"]');
        const card = popup?.querySelector('[part="card"]');
        const cardBody = card?.shadowRoot?.querySelector('[part="body"]');
        cardBody?.setAttribute("style", "padding: 10px;");
    });

    const callOutRef = useRef<callout>(null);

    const openCallOut = (e: any) => {
        callOutRef.current?.hide();
        callOutRef.current?.show();
    }

    return (
        <>
            <Icon name='info' id={name} style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4", display: displayValue || ''}}></Icon>
            <Callout id={name + '_callout'} ref={callOutRef} anchor={name} noCloseButton>
                {message}
            </Callout>
        </>
    );
};